import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Typography } from "@/components/ui/typography";
import { formatNumber } from "@/utils/format/formatNumber";

interface CheckboxSectionProps {
  options: { id: string; label: string; count?: number }[];
  selectedValues: string[];
  onChange: (values: string[]) => void;
}

export const CheckboxSection: React.FC<CheckboxSectionProps> = ({
  options,
  selectedValues,
  onChange,
}) => {
  const handleCheckboxChange = (optionId: string, checked: boolean) => {
    if (checked) {
      onChange([...selectedValues, optionId]);
    } else {
      onChange(selectedValues.filter((id) => id !== optionId));
    }
  };

  return (
    <div className="grid grid-cols-2 gap-3.5 mt-4">
      {options.map((option) => (
        <div key={option.id} className="flex items-center space-x-2">
          <Checkbox
            id={option.id}
            checked={selectedValues.includes(option.id)}
            onCheckedChange={(checked) =>
              handleCheckboxChange(option.id, !!checked)
            }
          />
          <Label
            htmlFor={option.id}
            className="text-[13px] font-normal cursor-pointer flex-1 gap-1 block"
          >
            {option.label}{" "}
            {option.count ? (
              <Typography color="black300" variant="captionRegular" as="span">
                ({formatNumber(option.count)})
              </Typography>
            ) : null}
          </Label>
        </div>
      ))}
    </div>
  );
};
